export enum ColorModeOptions {
    Colored = 'Colored',
    Dark = 'Dark',
    LightGrey = 'Light Grey',
    LightGreyBlueGreen = 'Light Grey blue & green',
    LightGreyBlueGreen2 = 'Light Grey blue & green 2',
    WhiteMode = 'White Mode',
    WhiteBlueGreen = 'White blue & green',
}
